import { SET_FEATURE_FLAGS } from '@/stores/FeatureFlags/mutations'
import * as gqlQuery from './queries.graphql'

import { useGraphQL } from '@/composables/graphQL'

export default {
  getFeatureFlags: async ({ commit }) => {
    try {
      const { response } = await useGraphQL(gqlQuery.GetFeatureFlags, {})
      if (response?.data) {
        const featureFlagArray = response.data.getFeatureFlags.items
        const featureFlags = featureFlagArray.reduce((acc, featureFlag) => {
          acc[featureFlag.id] = featureFlag.state
          return acc
        }, {})
        commit(SET_FEATURE_FLAGS, featureFlags)
      }
    } catch (err) {
      console.error('Error fetching feature flags', err)
    }
  },
}
